import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const hallData = [
  {
    name: "MECH / EEE BLOCK",
    classes: [
      { label: "Ground floor", halls: "102 - 105" },
      { label: "1st floor", halls: "111 - 119" },
      { label: "1st floor", halls: "Mechanical Seminar Hall" },
      { label: "2nd floor", halls: "121 - 128" },
    ],
  },
  {
    name: "MBA BLOCK",
    classes: [
      { label: "Ground floor", halls: "201 - 204" },
      { label: "1st floor", halls: "211 - 214" },
      { label: "2nd floor", halls: "221 - 224" },
      { label: "2nd floor", halls: "MBA Seminar Hall" },
    ],
  },
  {
    name: "CSE BLOCK",
    classes: [
      { label: "Ground floor", halls: "302" },
      { label: "1st floor", halls: "311 - 314" },
      { label: "2nd floor", halls: "321 - 324" },
      { label: "3rd floor", halls: "332 - 335" },
    ],
  },
  {
    name: "CSE / IT BLOCK",
    classes: [
      { label: "Ground floor", halls: "402 - 404" },
      { label: "1st floor", halls: "411 - 414" },
      { label: "2nd floor", halls: "421 - 429" },
      { label: "3rd floor", halls: "431 - 437" },
    ],
  },
  {
    name: "IT BLOCK",
    classes: [
      { label: "Ground floor", halls: "502 - 504" },
      { label: "1st floor" , halls: "Lab Allocation"},
      { label: "2nd floor", halls: "521 - 524" },
      { label: "3rd floor", halls: "532 - 535" },
    ],
  },
      {
    name: "CIVIL / FT BLOCK",
    classes: [
      { label: "Ground floor", halls: "601 - 604" },
      { label: "2nd floor", halls: "621 - 625" },
      { label: "3rd floor", halls: "631 - 632" },
      { label: "4th floor", halls: "641 - 645" },
    ],
  },
  {
    name: "ECE / BME BLOCK",
    classes: [
      { label: "Ground floor", halls: "APJ Hall" },
      { label: "1st floor", halls: "911 - 916" },
      { label: "2nd floor", halls: "921 - 926" },
      { label: "3rd floor", halls: "931 - 936" },
      { label: "4th floor", halls: "941 - 945" },
    ],
  },
  {
    name: "MCA / GREEN BUILDING BLOCK",
    classes: [
      { label: "Ground floor", halls: "1001 - 1005" },
      { label: "1st floor", halls: "1012 - 1015" },
      { label: "1st Floor (SEMINAR HALL)", halls: "IT SH01, IT SH02, IT SH03, IT SH04" },
      { label: "2nd floor", halls: "1022 - 1025" },
    ],
  },
  {
    name: "AI BLOCK",
    classes: [
      { label: "Ground floor", halls: "" },
      { label: "1st floor", halls: "" },
      { label: "2nd floor", halls: "" },
      { label: "3rd floor", halls: "" },
      { label: "4th floor", halls: "" },
      { label: "5th floor", halls: "" },
    ],
  },
];

const labData = [
  {
    name: "CSE BLOCK",
    labs: [
      { label: "Ground floor", labs: "CONFERENCE HALL [401]" },
      { label: "Ground floor", labs: "E F CODD Lab [402]" },
      { label: "Ground floor", labs: "IOT Lab" },
      { label: "Ground floor", labs: "CSE DEPT LIB" },
      { label: "3rd floor", labs: "Ken Thompson Lab" },
    ],
  },
  {
    name: "IT BLOCK",
    labs: [
      { label: "1st floor", labs: "IT Language Lab 1" },
      { label: "1st floor", labs: "IT Language Lab 2" },
      { label: "1st floor", labs: "IT project Lab 1" },
      { label: "1st floor", labs: "IT Project Lab 2" },
      { label: "3rd floor", labs: "IT IOT Lab" },
    ],
  },
  {
    name: "MBA BLOCK",
    labs: [
      { label: "Ground floor", labs: "PG Auditorium" },
      { label: "Ground floor", labs: "IBM / Charles Ranlett Lab" },
      { label: "1st floor", labs: "Shiva Ayyadurai Lab / John MCcarthy Lab" },
      { label: "1st floor", labs: "MBA Computer Lab 1" },
      { label: "2nd floor", labs: "Drawing Hall [D1 & D2]" },
    ],
  },
  {
    name: "MCA / GREEN BUILDING BLOCK",
    labs: [
      { label: "Ground Floor", labs: "Charles Babbage Computer Lab" },
      { label: "Ground Floor", labs: "Steve Jobs (IOS) Lab" },
      { label: "1st Floor", labs: "Dennis Ritchie Lab / Charles Babbage Lab" },
      { label: "1st Floor (SEMINAR HALL)", labs: "IT SH01 ,IT SH02 ,IT SH03, IT SH04 " },
      { label: "2nd Floor", labs: "MCA Lab" },
    ],
  },
  // {
  //   name: "MAIN BUILDING",
  //   labs: [

  //   ],
  // },
  {
    name: "MECH BLOCK / MAIN BUILDING",
    labs: [
      { label: "Ground floor", labs: "IT Main Lab 1 (OLD)" },
      { label: "Ground floor", labs: "IT Main Lab 2 (NEW)" },
      { label: "Ground floor", labs: "3DX Lab" },
      { label: "Ground floor", labs: "CAD / CAM Lab" },
      { label: "1st floor", labs: "Mechanical Seminar Hall" },
      { label: "1st floor", labs: "Dynamics of Machinery Lab" },
      { label: "1st floor", labs: "Metrology & Measurement Lab" },
      { label: "1st floor", labs: "Mechatronics (Simulation)" },
      { label: "1st floor", labs: "Library" },
    ],
  },
    {
    name: "EEE BLOCK",
    labs: [
      { label: "Ground floor", labs: "Physics Lab" },
      { label: "1st floor", labs: "Chemistry Lab" },
      { label: "1st floor", labs: "Simulation Lab" },
      { label: "1st floor", labs: "Power System Protection Lab" },
      { label: "1st floor", labs: "Power Electronics Lab" },
      { label: "1st floor", labs: "Digital IC and Microprocessor Lab" },
      { label: "1st floor", labs: "Control & Instrumentation Lab" },
      { label: "1st floor", labs: "Sona Speed (R&D)" },
      { label: "2nd floor", labs: "Edison Hall" },
    ],
  },
  {
    name: "ECE",
    labs: [
      { label: "Ground floor", labs: "Industry Safety Lab" },
      { label: "Ground floor", labs: "Intel Intelligent Systems" },
      { label: "Ground floor", labs: "APJ HAll" },
      { label: "Ground floor", labs: "Sona Signal & Image Processing Research Centre" },
      { label: "1st floor", labs: "Microwave & Optical Lab" },
      { label: "1st floor", labs: "Electronics & Digital IC Lab" },
      { label: "1st floor", labs: "DSP Lab / VLSI Lab / PCB Lab" },
      { label: "2nd floor", labs: "Linear Integrated Circuits Lab" },
      { label: "2nd floor", labs: "Communication Lab" },
      { label: "2nd floor", labs: "Microprocessor & Microcontroller Lab" },
      { label: "2nd floor", labs: "Library" },
      { label: "3rd floor", labs: "Project / Research Lab" },
    ],
  },
  {
    name: "CIVIL / FT BLOCK",
    labs: [
      { label: "Ground floor", labs: "Survey Laboratory" },
      { label: "Ground floor", labs: "Soil Laboratory" },
      { label: "Ground floor", labs: "Fabric Structure (Textile Testing & Quality Control) Laboratory" },
      { label: "1st floor", labs: "CADD Laboratory" },
      { label: "1st floor", labs: "Environment Engineering Laboratory" },
      { label: "1st floor", labs: "Gemini Cad Sponsored (Textile & Garment Cad) Laboratory" },
      { label: "1st floor", labs: "Conference Hall" },
      { label: "3rd floor", labs: "Draping Technique (Pattern Making) Laboratory" },
      { label: "3rd floor", labs: "Garment Construction Laboratory" },
      { label: "3rd floor", labs: "FT (R & D) Laboratory" },
      { label: "3rd floor", labs: "Library" },
    ],
  },
];

const Hall = () => {
  const navigate = useNavigate();
  const [view, setView] = useState("classes");

  const dataToRender = view === "classes" ? hallData : labData;

return (
  <div className="mt-12 min-h-screen bg-gray-00 text-white px-4">
    <Helmet>
      <title>Hall Details</title>
    </Helmet>

    {/* Heading */}
    <h1 className="text-3xl text-center font-semibold mb-6">Hall Details [Last Update 2026]</h1>

    {/* Toggle Buttons */}
    <div className="flex flex-wrap justify-center gap-4 mb-6">
      <button
        onClick={() => setView("classes")}
        className={`px-4 py-2 border rounded-md transition ${
          view === "classes"
            ? "bg-blue-600 text-white"
            : "bg-transparent text-white border-white hover:bg-white hover:text-blue-600"
        }`}
      >
        Class Details
      </button>
      <button
        onClick={() => setView("labs")}
        className={`px-4 py-2 border rounded-md transition ${
          view === "labs"
            ? "bg-blue-600 text-white"
            : "bg-transparent text-white border-white hover:bg-white hover:text-blue-600"
        }`}
      >
        Lab | Hall Details
      </button>
    </div>

    {/* Data Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {dataToRender.map((block, index) => (
        <div
          key={index}
          className="w-full bg-[#1d1f2a] border border-gray-500 rounded-lg shadow-md"
        >
          <h2 className="text-center font-bold p-4 border-b border-gray-500 text-lg">
            {block.name}
          </h2>

          {(view === "classes" ? block.classes : block.labs || []).map((item, i) => (
            <div key={i} className="flex border border-gray-700 min-h-[56px]">
              <div className="w-1/2 bg-blue-800 text-white p-4 text-sm md:text-base flex items-center">
                {item.label}
              </div>
              <div className="w-1/2 p-4 text-sm md:text-base flex items-center border-l border-gray-800">
                {view === "classes" ? item.halls : item.labs || "No Labs"}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>

    {/* Go Back Button */}
    {/* <div className="flex justify-center mt-10">
      <button
        onClick={() => navigate(-1)}
        className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-md transition"
      >
        Go Back
      </button>
    </div> */}
    <br />
  </div>
);

};

export default Hall;


// import React from "react";
// import { Helmet } from "react-helmet";
// import { useNavigate } from "react-router-dom";

// const hallData = [
//   {
//     name: "MECH/EEE BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "102 - 106" },
//       { label: "1st floor", halls: "111 - 119" },
//       { label: "2nd floor", halls: "121 - 128" },
//     ],
//   },
//   {
//     name: "MBA BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "201 - 202" },
//       { label: "1st floor", halls: "211 - 214" },
//       { label: "2nd floor", halls: "221 - 224" },
//     ],
//   },
//   {
//     name: "CSE BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "302" },
//       { label: "1st floor", halls: "311 - 314" },
//       { label: "2nd floor", halls: "321 - 324" },
//       { label: "3nd floor", halls: "332 - 335" },
//     ],
//   },
//   {
//     name: "CSE/IT BLOCK",
//     floors: [
//       { label: "1st floor", halls: "411 - 415" },
//       { label: "2st floor", halls: "421 - 426" },
//       { label: "3rd floor", halls: "431 - 435" },
//     ],
//   },
//   {
//     name: "IT BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "502 - 504" },
//       { label: "2nd floor", halls: "521 - 524" },
//       { label: "3rd floor", halls: "532 - 535" },
//     ],
//   },
//   {
//     name: "CIVIL BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "601 - 603" },
//       { label: "1st floor", halls: "614" },
//       { label: "2nd floor", halls: "621 - 625" },
//       { label: "3rd floor", halls: "631 - 634" },
//       { label: "4rd floor", halls: "641 - 645" },
//     ],
//   },
//   {
//     name: "ECE BLOCK",
//     floors: [
//       { label: "1st floor", halls: "911 - 914" },
//       { label: "2nd floor", halls: "921 - 926" },
//       { label: "3rd floor", halls: "932 - 936" },
//       { label: "4rd floor", halls: "942 - 945" },
//     ],
//   },
//   {
//     name: "MCA BLOCK",
//     floors: [
//       { label: "Ground floor", halls: "1001 - 1005" },
//       { label: "1st floor", halls: "1012 - 1014" },
//     ],
//   },
// ];

// const Hall = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="mt-12 min-h-screen">
//       <Helmet>
//         <title>Hall Details</title>
//       </Helmet>

//       <h1 className="text-3xl text-center font-semibold mb-6">Hall Details</h1>

//       <div className="flex flex-col items-center">
//         {hallData.map((block, index) => (
//           <div key={index} className="w-80 border mb-6">
//             <h2 className="text-center font-bold p-4 border-b">{block.name}</h2>
//             {block.floors.map((floor, i) => (
//               <div key={i} className="flex">
//                 <div className="w-1/2 bg-blue-900 text-white p-2">{floor.label}</div>
//                 <div className="w-1/2 p-2 border-l">{floor.halls}</div>
//               </div>
//             ))}
//           </div>
//         ))}
//       </div>

//       <div className="flex justify-center mt-4">
//         <button
//           onClick={() => navigate(-1)}
//           className="bg-blue-600 text-white px-8 py-2 rounded"
//         >
//           Go Back
//         </button>
//       </div>
//       <br />
//     </div>
//   );
// };

// export default Hall;

